import { render, staticRenderFns } from "./Negociacoes.vue?vue&type=template&id=4891aa37&"
import script from "./Negociacoes.vue?vue&type=script&lang=js&"
export * from "./Negociacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports